var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTable',_vm._g({attrs:{"loading":_vm.isLoading,"headers":_vm.headers,"actions":[],"list":_vm.data.data},scopedSlots:_vm._u([{key:"item.context_from",fn:function(ref){
var header = ref.header;
var item = ref.item;
return [_c('span',{domProps:{"textContent":_vm._s(header.getValue(item))}})]}},{key:"item.context_to",fn:function(ref){
var header = ref.header;
var item = ref.item;
return [_c('span',{domProps:{"textContent":_vm._s(header.getValue(item))}})]}},{key:"item.ate_element",fn:function(ref){
var header = ref.header;
var item = ref.item;
return [_c('div',{domProps:{"innerHTML":_vm._s(header.getValue(item))}})]}},{key:"item.ate_from",fn:function(ref){
var header = ref.header;
var item = ref.item;
return [_c('div',{domProps:{"innerHTML":_vm._s(header.getValue(item))}})]}},{key:"item.ate_to",fn:function(ref){
var header = ref.header;
var item = ref.item;
return [_c('div',{domProps:{"innerHTML":_vm._s(header.getValue(item))}})]}}])},_vm.$listeners || {}))}
var staticRenderFns = []

export { render, staticRenderFns }